import{useLayoutEffect as r,useEffect as o}from"react";import{runningInBrowser as t}from"../const/device.js";var e=()=>t?r:o;export{e as useIsomorphicEffect};
